const Validator = require('validator')

module.exports = (validateSettings, tr) => {
  const hasProperty = (obj, key) => {
    return !!obj && Object.prototype.hasOwnProperty.call(obj, key)
  }
  const toString = Object.prototype.toString
  const typeOf = (obj) => {
    return toString.call(obj).slice(8, -1).toLowerCase()
  }
  const getValue = (val, defaultVal) => {
    if (typeOf(val) === 'string' && val === '') return defaultVal
    if (typeOf(val) === 'array' && val.length === 0) return defaultVal
    if (typeOf(val) === 'object' && Object.keys(val).length === 0) { return defaultVal }

    return val
  }

  return {
    validate: (fieldName, keys, val) => {
      if (!hasProperty(validateSettings, keys)) {
        return tr('{{fieldName}} の設定ファイルがありません。', { fieldName })
      }

      if (typeOf(val) === 'array' || typeOf(val) === 'object') {
        return tr('{{fieldName}} は適切な値ではありません。', { fieldName })
      }

      if (typeOf(val) === 'number') {
        val = val + ''
      }

      if (val === undefined || val === null) {
        val = ''
      }

      const paramSettings = validateSettings[keys]
      if (Validator.isEmpty(val)) {
        if (paramSettings.required) {
          return tr('{{fieldName}} は必須入力です。', { fieldName })
        }
        return ''
      }

      if (
        hasProperty(paramSettings, 'isAlphanumeric') &&
        !Validator.isAlphanumeric(
          val,
          getValue(paramSettings.isAlphanumeric, 'en-US')
        )
      ) {
        return tr('{{fieldName}} は数字と文字のみで入力してください。', {
          fieldName
        })
      }

      if (
        hasProperty(paramSettings, 'isLength') &&
        !Validator.isLength(val, getValue(paramSettings.isLength, {}))
      ) {
        if (
          paramSettings.isLength.min !== undefined &&
          paramSettings.isLength.max !== undefined
        ) {
          return tr(
            '{{fieldName}} は {{min}} 文字以上 {{max}} 文字以下で入力してください。',
            {
              fieldName,
              min: paramSettings.isLength.min,
              max: paramSettings.isLength.max
            }
          )
        } else if (
          paramSettings.isLength.min === undefined &&
          paramSettings.isLength.max !== undefined
        ) {
          return tr('{{fieldName}} は {{max}} 文字以下で入力してください。', {
            fieldName,
            max: paramSettings.isLength.max
          })
        } else if (
          paramSettings.isLength.min !== undefined &&
          paramSettings.isLength.max === undefined
        ) {
          return tr('{{fieldName}} は {{min}} 文字以上で入力してください。', {
            fieldName,
            min: paramSettings.isLength.min
          })
        }
      }

      if (
        hasProperty(paramSettings, 'isInt') &&
        !Validator.isInt(val, getValue(paramSettings.isInt, {}))
      ) {
        if (
          paramSettings.isInt.min !== undefined &&
          paramSettings.isInt.max !== undefined
        ) {
          return tr(
            '{{fieldName}} は {{min}} から {{max}} までの数字を入力してください。',
            {
              fieldName,
              min: paramSettings.isInt.min,
              max: paramSettings.isInt.max
            }
          )
        } else if (
          paramSettings.isInt.min === undefined &&
          paramSettings.isInt.max !== undefined
        ) {
          return tr('{{fieldName}} は {{max}} 以下の数字を入力してください。', {
            fieldName,
            max: paramSettings.isInt.max
          })
        } else if (
          paramSettings.isInt.min !== undefined &&
          paramSettings.isInt.max === undefined
        ) {
          return tr('{{fieldName}} は {{min}} 以上の数字を入力してください。', {
            fieldName,
            min: paramSettings.isInt.min
          })
        } else if (
          paramSettings.isInt.min === undefined &&
          paramSettings.isInt.max === undefined
        ) {
          return tr('{{fieldName}} は {{min}} 以上の数字を入力してください。', {
            fieldName,
            min: paramSettings.isInt.min
          })
        }
      }

      if (
        hasProperty(paramSettings, 'isFloat') &&
        !Validator.isFloat(val, getValue(paramSettings.isFloat, {}))
      ) {
        if (
          paramSettings.isFloat.min !== undefined &&
          paramSettings.isFloat.max !== undefined
        ) {
          return tr(
            '{{fieldName}} は {{min}} から {{max}} までの数字を入力してください。',
            {
              fieldName,
              min: paramSettings.isFloat.min,
              max: paramSettings.isFloat.max
            }
          )
        } else if (
          paramSettings.isFloat.min === undefined &&
          paramSettings.isFloat.max !== undefined
        ) {
          return tr('{{fieldName}} は {{max}} 以下の数字を入力してください。', {
            fieldName,
            max: paramSettings.isFloat.max
          })
        } else if (
          paramSettings.isFloat.min !== undefined &&
          paramSettings.isFloat.max === undefined
        ) {
          return tr('{{fieldName}} は {{min}} 以上の数字を入力してください。', {
            fieldName,
            min: paramSettings.isFloat.min
          })
        } else if (
          paramSettings.isFloat.min === undefined &&
          paramSettings.isFloat.max === undefined
        ) {
          return tr('{{fieldName}} は {{min}} 以上の数字を入力してください。', {
            fieldName,
            min: paramSettings.isFloat.min
          })
        }
      }

      if (
        hasProperty(paramSettings, 'isEmail') &&
        !Validator.isEmail(val, getValue(paramSettings.isEmail, {}))
      ) {
        return tr('{{fieldName}} はメールアドレスの形式で入力してください。', {
          fieldName
        })
      }

      if (
        hasProperty(paramSettings, 'isMobilePhone') &&
        !Validator.isMobilePhone(
          val,
          getValue(paramSettings.isMobilePhone[0], 'any'),
          getValue(paramSettings.isMobilePhone[1], {})
        )
      ) {
        return tr('{{fieldName}} は電話番号の形式で入力してください。', {
          fieldName
        })
      }

      if (
        hasProperty(paramSettings, 'isEmail') &&
        !Validator.isEmail(val, getValue(paramSettings.isEmail, {}))
      ) {
        return tr('{{fieldName}} はメールアドレスの形式で入力してください。', {
          fieldName
        })
      }

      if (hasProperty(paramSettings, 'matches')) {
        const reg = new RegExp(getValue(paramSettings.matches[0], ''))
        if (
          !Validator.matches(
            val,
            reg,
            getValue(paramSettings.matches[1], '')
          )
        ) {
          return tr('{{fieldName}} は正しい形式で入力してください。', {
            fieldName
          })
        }
      }

      return ''
    },
    compare: (fieldName, rule, ...val) => {}
  }
}
